// eslint-disable-next-line import/prefer-default-export
export const GUID_VIDE = '00000000-0000-0000-0000-000000000000';
export const INFINITE_DAY = new Date(2700, 12, 1);
